import { verifyResponseType } from '../VoPayApi.validation';
import { VoPayResponse } from '../VoPayApi.types';
import { type Http } from '../../../../services/http';

import {
  AddressVerificationUrlInfoResponse,
  ContactVerificationApi,
  ContactVerificationGenerateEmbedUrlRequest,
  ContactVerificationGenerateEmbedUrlResponse,
  FetchBillProvidersApiResponse,
  LoginToBillProviderResponse,
  SendContactVerificationOTPResponse,
  IDVerificationUrlInfoResponse,
  UploadContactVerificationDocumentResponse,
  ContactVerificationUrlInfoRequest,
} from './contactVerification.types';

export default function contactVerification(http: Http): ContactVerificationApi {
  return {
    contactVerification: {
      fetchAddressVerificationUrlInfo: async (params, source) => {
        const url = '/portal/retrieve-single-use-token';

        const { data } = await http.get<typeof params>({
          url,
          config: {
            params: {
              Token: params.Token,
              ApplicationType: 'verification',
            },
          },
          source,
        });

        const possibleResTypes: VoPayResponse[] = [VoPayResponse.ApiResponse];
        const res = verifyResponseType<AddressVerificationUrlInfoResponse>(url, data, possibleResTypes);

        return {
          ...res,
        };
      },
      fetchContactVerificationUrlInfo: async (params, source) => {
        const url = '/portal/retrieve-single-use-token';

        const { data } = await http.get<ContactVerificationUrlInfoRequest>({
          url,
          config: {
            params: {
              Token: params.Token,
              ApplicationType: 'contact-verification',
            },
          },
          source,
        });

        const possibleResTypes: VoPayResponse[] = [VoPayResponse.ApiResponse];
        const res = verifyResponseType<IDVerificationUrlInfoResponse>(url, data, possibleResTypes);

        return {
          ...res,
        };
      },
      fetchBillProviders: async (params) => {
        const url = '/contact-verification/address/sources';

        const { data } = await http.get<typeof params>({
          url,
          config: { params },
        });

        const res = verifyResponseType<FetchBillProvidersApiResponse>(url, data, [VoPayResponse.ApiResponse]);

        return {
          ...res,
          Sources: Object.values(res.Sources || {}),
        };
      },
      loginToBillProvider: async (params) => {
        const url = '/contact-verification/address/connect';

        const { data } = await http.post<typeof params>({
          url,
          config: { params },
        });

        return verifyResponseType<LoginToBillProviderResponse>(url, data, [VoPayResponse.ApiResponse]);
      },
      sendOTP: async (params) => {
        const url = '/contact-verification/address/mfa-answer';

        const { data } = await http.post<typeof params>({
          url,
          config: { params },
        });

        return verifyResponseType<SendContactVerificationOTPResponse>(url, data, [VoPayResponse.ApiResponse]);
      },
      uploadDocument: async (params) => {
        const url = '/contact-verification/upload-document';

        const { data } = await http.post<typeof params>({
          url,
          config: {},
          body: JSON.stringify(params),
        });

        return verifyResponseType<UploadContactVerificationDocumentResponse>(url, data, [VoPayResponse.ApiResponse]);
      },
      generateEmbedUrl: async (params, source) => {
        const url = '/contact-verification/generate-embed-url';

        const { data } = await http.post<ContactVerificationGenerateEmbedUrlRequest>({
          url,
          config: { params },
          source,
        });

        return verifyResponseType<ContactVerificationGenerateEmbedUrlResponse>(url, data, [VoPayResponse.ApiResponse]);
      },
    },
  };
}
